var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurgerMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#3D69FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3925 21.8356L17.3925 27.124C17.3928 27.3328 17.3403 27.5374 17.2412 27.7141C17.1421 27.8909 17.0004 28.0325 16.8325 28.1227C16.6332 28.2282 16.4116 28.2689 16.1927 28.24C15.9739 28.2111 15.7667 28.1139 15.5948 27.9594L12.7386 25.3152C12.6318 25.2114 12.5462 25.0831 12.4875 24.939C12.4288 24.7948 12.3984 24.6382 12.3984 24.4798C12.3984 24.3214 12.4288 24.1648 12.4875 24.0207C12.5462 23.8765 12.6318 23.7482 12.7386 23.6445L15.5948 21.0002C15.7667 20.8457 15.9739 20.7485 16.1927 20.7196C16.4116 20.6908 16.6332 20.7314 16.8325 20.8369C17.0004 20.9271 17.1421 21.0687 17.2412 21.2455C17.3403 21.4222 17.3928 21.6268 17.3925 21.8356Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6376 16H14.918",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3977 24.4785L19.958 24.4785",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6376 32.1494H14.918",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burger-menu.75e8db520c05285529bba5b0e8111e59.svg";
export { ForwardRef as ReactComponent };